import { useTheme } from '@mui/material/styles';
import { Box, Select, MenuItem } from '@mui/material';

import { ReactComponent as DropdownIcon } from 'assets/images/icons/icn_pagination_chevron_down.svg';

export default function SelectMenu({ menuList = [], onChangeItem, disabled = false }) {
  const theme = useTheme();

  return (
    <Box sx={{ overflow: 'visible' }}>
      <Select
        IconComponent={DropdownIcon}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '14px',
              mt: '2px',
              boxShadow: '0px 1px 4px rgba(0,0,0,0.08)',
              maxHeight: '190px',
            },
          },
          MenuListProps: {
            sx: {
              '& .MuiMenuItem-root': {
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                py: 1,
                maxWidth: '300px',
                fontSize: theme.typography.customFontSize[2],
                color: theme.palette.primary.main,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
              '& .Mui-selected': {
                backgroundColor: `${theme.palette.primary.subBlue} !important`,
                marginTop: 0,
                marginBottom: 0,
              },
              '& .MuiMenuItem-root:hover': {
                backgroundColor: `${theme.palette.primary.lightBlue} !important`,
              },
              '& .Mui-selected:hover': {
                backgroundColor: 'rgba(23, 38, 100, 0.12) !important',
              },
            },
          },
        }}
        sx={{
          width: '300px',
          height: '30px',
          borderRadius: '8px',
          fontWeight: 600,
          fontSize: theme.typography.customFontSize[2],
          cursor: disabled ? 'no-drop' : 'pointer',
          '& .MuiSelect-select': {
            cursor: disabled ? 'no-drop' : 'pointer',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            pr: 4,
          },
          '& .MuiSvgIcon-root': {
            cursor: disabled ? 'no-drop' : 'pointer',
          },

          '& .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${theme.palette.primary.greyFifth}`,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.mainHover,
          },
        }}
        value={menuList?.find(opt => opt.isActive)?.value}
        displayEmpty
        renderValue={selected => {
          if (!selected) {
            return <span style={{ color: theme.palette.primary.greyThird }}>Select</span>;
          } else {
            return <span>{menuList?.find(opt => opt?.value === selected)?.label}</span>;
          }
        }}
        onChange={e => onChangeItem(e.target.value)}
        disabled={disabled}
      >
        {menuList?.map((opt, index) => (
          <MenuItem key={index} value={opt.value}>
            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
              {opt.label}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
